// Colour tokens match the DateRangePicker / MultiSelect clear affordances so
// every "clear this field" control in the app reads the same.
.root {
  align-items: center;
  background: none;
  border: none;
  color: var(--color-muted);
  cursor: pointer;
  display: flex;
  flex-shrink: 0;
  padding: 0;
  transition: color 0.15s;

  &:hover {
    color: var(--color-foreground);
  }
}
